import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';


@Directive({
  selector: '[cmsSwiper]'
})
export class SwiperDirective implements AfterViewInit, OnChanges {

  @Input() public config: SwiperOptions = {};

  public swiper!: Swiper;

  constructor(private readonly el: ElementRef<HTMLElement>) {}

  public ngAfterViewInit(): void {
    this.initSwiper();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!changes.config.firstChange) {
      this.swiper.destroy();
      this.initSwiper();
    }
  }

  private initSwiper(): void {
    // Add pagination if enabled for getting the DOM html element
    this.addPaginationToConfig();
    this.swiper = new Swiper(this.el.nativeElement, this.config);
    this.swiper.init();
  }

  private addPaginationToConfig(): void {
    if (
      this.config?.pagination
      && typeof this.config.pagination === 'object'
      && this.config.pagination.el === undefined) {
      const paginationElement = this.el.nativeElement.querySelector('.swiper-pagination') as HTMLElement;
      this.config = {
        ...this.config,
        pagination: {
          ...this.config.pagination,
          el: paginationElement || undefined
        }
      };
    }
  }

}
